import React, { Component } from "react";

class FSRReportRow extends Component {
   render() {
      const props = this.props;
      return (
         <tr key={props.keys}>
            <td>{props.value["unit-sl-no"]}</td>
            <td>{props.value["vehicle-no"]}</td>
            <td>{props.value["model-no"]}</td>
            <td>{props.value["customer-name"]}</td>
            <td>{props.value["address"]}</td>
            <td>{props.value["date-of-inst"]}</td>
            <td>{props.value["month_diff"]}</td>
         </tr>
      );
   }
}

export default FSRReportRow;
